module.exports = {"code":"1","msg":"请求接口成功","data":{"algorithmType":1,"answerStyle":0,"curModuleId":590,"goodsType":0,"moduleConnectMode":0,"moduleIntro":"","questionnaireName":"疫情心理修复评估","showTip":false,"uiType":5,"whetherLastModule":true,"whetherMultiModule":false}}


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/getCurModuleIntro_id566.json
// module id = /vy1
// module chunks = 156 157